import * as React from 'react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  onApply: () => void
  onCancel: () => void
  applyLabel?: string
  cancelLabel?: string
  applyCount?: number
  size?: 'sm' | 'default' | 'lg'
  layout?: 'end' | 'fill'
}

const OptionsFooter: React.FC<IProps> = ({
  onApply,
  onCancel,
  applyLabel,
  cancelLabel,
  applyCount,
  size = 'default',
  layout = 'end',
}) => {
  const apply = applyLabel ?? Localization.translator.apply
  const cancel = cancelLabel ?? Localization.translator.cancel
  const applyText =
    typeof applyCount === 'number' && applyCount > 0
      ? `${apply} (${applyCount})`
      : apply

  const isFill = layout === 'fill'
  const buttonClassName = isFill ? 'tw:flex-1' : undefined

  return (
    <div
      data-slot="options-footer"
      data-layout={layout}
      className={`tw:flex tw:items-center tw:gap-2 tw:shrink-0 ${
        isFill ? '' : 'tw:justify-end'
      }`}
    >
      <Button
        variant="outline"
        size={size}
        onClick={onCancel}
        className={buttonClassName}
      >
        {cancel}
      </Button>
      <Button size={size} onClick={onApply} className={buttonClassName}>
        {applyText}
      </Button>
    </div>
  )
}

export default OptionsFooter
